import Klass from '@/models/Klass';
import { ScheduledLessonTypeEnum } from '@/models/ScheduledLesson';
import { translateKlassName } from './translateKlassName';
import CoursePath from '@/models/CoursePath';
import { formatLessonNamePrefix } from './lesson/name';
interface MakeLessonHeadTitleParams {
  lessonOrder: number;
  lessonType?: ScheduledLessonTypeEnum;
  coursePath?: CoursePath;
  klass?: Klass;
}

export const makeLessonHeadTitle = ({
  lessonOrder,
  coursePath,
  klass,
  lessonType,
}: MakeLessonHeadTitleParams) => {
  const lessonAbbreviation = formatLessonNamePrefix({
    lessonOrder,
    scheduledLessonType: lessonType,
  });
  const courseAbbreviation = coursePath?.course.abbreviation ?? '';
  const klassName = translateKlassName(klass?.name);
  return `${lessonAbbreviation} - ${klassName || courseAbbreviation}`;
};
